import { createRequestPayload } from './createRequestPayload';
import { TMappedAnswersState } from '../types';
import { IHttpApi } from '@cian/http-api/shared/http';
import {
  fetchCreateMessage,
  ICreateMessageResponse200,
  ICreateMessageResponse400,
} from '../../../repositories/demand/v4/create-message';
import { IApplicationState } from '../../../types/redux';
import { selectIsWebview } from '../../../selectors/selectIsWebview';
import { selectPage } from '../../../selectors/selectPage';

interface IParams {
  httpApi: IHttpApi;
  mappedAnswersState: TMappedAnswersState;
  state: IApplicationState;
}

export const createRequest = async (params: IParams) => {
  const { httpApi, mappedAnswersState, state } = params;
  const isWebview = selectIsWebview(state);
  const {
    platform,
    queryParams: { cian_source },
  } = selectPage(state);

  const parameters = createRequestPayload({
    mappedAnswersState,
    isWebview,
    platform,
    cian_source,
  });

  return fetchCreateMessage<ICreateMessageResponse200, ICreateMessageResponse400>({
    httpApi,
    parameters,
  });
};
